/**
 * Static image URLs.
 *
 * Images live in the Bunny storage zone under /images and are served by the pull
 * zone. BUN_PUBLIC_CDN_URL is inlined into the browser bundle at build time
 * (see the `--env='BUN_PUBLIC_*'` flag on the build script); when it is unset the
 * bundled asset is used instead, so the site still renders without Bunny.
 */

const CDN = (process.env.BUN_PUBLIC_CDN_URL ?? '').replace(/\/+$/, '');

export function cdnImage(name: string, bundled: string): string {
	return CDN ? `${CDN}/images/${name}` : bundled;
}
